import {  t  } from "@/client/libs/dummy-i18n";
import { ChartLineUp, Files, House, SignOut, Users } from "@phosphor-icons/react";
import { Button, Separator } from "@stackmorph/ui";
import { motion } from "framer-motion";
import { Link, Outlet, useLocation, useNavigate } from "react-router";

import { UserAvatar } from "@/client/components/user-avatar";
import { useUser } from "@/client/services/user";

export const AdminLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useUser();

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    navigate("/admin/login");
  };

  const navItems = [
    { icon: House, label: t`Dashboard`, href: "/admin/dashboard" },
    { icon: Users, label: t`Users`, href: "/admin/users" },
    { icon: Files, label: t`Resumes`, href: "/admin/resumes" },
    { icon: ChartLineUp, label: t`Logs`, href: "/admin/logs" },
  ];

  return (
    <div className="flex h-screen w-full bg-background">
      {/* Sidebar */}
      <motion.aside
        initial={{ x: -20, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        className="flex w-64 flex-col border-r bg-secondary/30 backdrop-blur-xl"
      >
        <div className="flex h-16 items-center gap-2 px-6 font-bold text-primary">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-primary-foreground">
            A
          </div>
          <span>Admin Panel</span>
        </div>

        <Separator />

        <nav className="flex-1 space-y-1 p-4">
          {navItems.map((item) => {
            const isActive = location.pathname.startsWith(item.href);
            return (
              <Link key={item.href} to={item.href}>
                <Button
                  variant={isActive ? "secondary" : "ghost"}
                  className={`w-full justify-start gap-3 ${isActive ? "bg-primary/10 text-primary" : ""}`}
                >
                  <item.icon size={18} />
                  {item.label}
                </Button>
              </Link>
            );
          })}
        </nav>

        <div className="p-4">
          <div className="mb-4 flex items-center gap-3 rounded-lg border bg-background p-3">
            <UserAvatar size={32} />
            <div className="flex-1 overflow-hidden">
              <p className="truncate text-sm font-medium">{user?.name}</p>
              <p className="truncate text-xs text-muted-foreground">{user?.email}</p>
            </div>
          </div>

          <Button
            variant="outline"
            className="w-full justify-start gap-3 text-error hover:bg-error/10 hover:text-error"
            onClick={handleLogout}
          >
            <SignOut size={18} />
            {t`Logout`}
          </Button>
        </div>
      </motion.aside>

      {/* Main Content */}
      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
};
